import React from 'react';
import {Link} from "react-router-dom";

export default class RelationShipAddress extends React.Component {
	constructor(props) {
		super(props);

		let _state = {};
		_state.params = {};

		window.Route.on({
			'/v2/relationships/address': () => {
				_state = {
					mode: 'list',
					relationship: false,
					relationship_address: [],
				};
			},
			'/v2/relationships/address/new': () => {
				_state = {
					mode: 'create',
					relationship: false,
					relationship_address: {
						is_default: true
					},
				};
			},
			'/v2/relationships/address/:relationship_address_id': (params) => {
				_state = {
					mode: 'view',
					relationship: false,
					params: params,
					relationship_address: [],
				};
			},
			'/v2/relationships/address/:relationship_address_id/edit': (params) => {
				_state = {
					mode: 'edit',
					relationship: false,
					params: params,
					relationship_address: [],
				};
			},
		}).match();

		_state.is_loading = true;
		_state.qs = window.Global.getAllQueryStrings();

		this.state = _state;

		if (!this.state.qs.back) {
			this.state.backUrl = this.state.mode === 'create'
				? '/v2/relationships/address?id=' + this.state.qs.id
				: '/v2/relationships/address/' + this.state.relationship_address.id + '?id=' + this.state.qs.id
		} else {
			this.state.backUrl = '/relationships?id=' + this.state.qs.id;
		}

		this.$parent = React.createRef();
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			window.Route.on({
				'/v2/relationships/address': () => {
					this.setState({
						mode: 'list',
						is_loading: true,
					}, () => {
						this.fetch();
					})
				},
				'/v2/relationships/address/new': () => {
					this.setState({
						mode: 'create',
						is_loading: true,
						relationship: false,
						relationship_address: [],
					}, () => {
						this.create();
					})
				},
				'/v2/relationships/address/:relationship_address_id': (params) => {
					this.setState({
						mode: 'view',
						is_loading: true,
						relationship: false,
						params: params,
						relationship_address: [],
					}, () => {
						this.view();
					});
				},
				'/v2/relationships/address/:relationship_address_id/edit': (params) => {
					this.setState({
						mode: 'edit',
						is_loading: true,
						relationship: false,
						params: params,
						relationship_address: [],
					}, () => {
						this.edit();
					});
				},
			}).match();
		} else if (this.props.location.search !== prevProps.location.search) {
			this.setState({
				mode: 'list',
				is_loading: true,
			}, () => {
				this.fetch();
			})
		}
	}

	componentDidMount() {
		if (this.state.mode === 'list') {
			this.fetch();
		}
		if (this.state.mode === 'create') {
			this.create();
		}
		if (this.state.mode === 'view') {
			this.view();
		}
		if (this.state.mode === 'edit') {
			this.edit();
		}
	}

	setupJqueryThailand() {
		window.$.Thailand({
			database: process.env.REACT_APP_PATH + '/libs/spaceship-web/jquery_Thailand/db.json',
			database_type: 'json',
			autocomplete_size: 20,
			$district: window.$('#district'),
			$amphoe: window.$('#city'),
			$province: window.$('#province'),
			$zipcode: window.$('#zipcode'),
		});
	}

	edit() {
		let loads = {};
		if (typeof google === 'undefined') {
			loads.google_map = {
				type: 'google_map',
				params: {
					'key': window.Global.google_map_key,
					'libraries': 'places'
				}
			};
		}

		window.Global.getDataViaMultiAjax().load(loads).done(() => {
			window.Global.ajax({
				method: 'GET',
				url: process.env.REACT_APP_DOMAIN + '/api/relationship',
				data: {relationship_id: this.state.qs.id},
				done: (response) => {
					this.setState({
						relationship: response.relationship[0],
					}, () => {
						let data = {};
						data.relationship_id = this.state.qs.relationship_id;
						data.request_data_relationship = 1;
						data.relationship_address_id = this.state.params.relationship_address_id;
						window.Global.ajax({
							method: 'GET',
							url: process.env.REACT_APP_DOMAIN + '/api/relationship_address',
							data: data,
							done: (response) => {
								response.relationship_address[0].phone_number = response.relationship_address[0].phone_number.replace("+66", "0");
								this.setState({
									is_loading: false,
									relationship_address: response.relationship_address[0],
									backUrl: '/v2/relationships/address/' + response.relationship_address[0].id + '?id=' + this.state.qs.id,
								}, () => {
									this.setupJqueryThailand();

									this.$parent = window.$(this.$parent.current);

									this.$parent.find('form').form2('setup', {
										is_default_xx_onChange: () => {
											this.setupAddressChange()
										}
									});
									this.$parent.find('form').form2('submit', {
										method: 'PUT',
										url: process.env.REACT_APP_DOMAIN + '/api/relationship_address',
										beforeSent: (object) => {
											object.relationship_address_id = response.relationship_address[0].id;
											return object;
										},
										loadingButton: window.$(this.$parent).find('#submit-button'),
										onSuccess: (response) => {
											// console.log(response);
											window.Global.messageTop({
												type: 'positive',
												message: 'บันทึกข้อมูลสำเร็จ'
											});
											if (this.state.qs.back) {
												window.location = this.state.backUrl;
											} else {
												this.props.history.push({
													pathname: '/v2/relationships/address/' + response.relationship_address.id,
													search: "?id=" + this.state.qs.id,
													state: null
												});
											}
										}
									})

									this.setupAddress()
								});
							},
							fail: () => {

							}
						});
					});
				},
				fail: () => {

				}
			});
		});
	}

	view() {
		let loads = {};
		if (typeof google === 'undefined') {
			loads.google_map = {
				type: 'google_map',
				params: {
					'key': window.Global.google_map_key,
					'libraries': 'places'
				}
			};
		}

		window.Global.getDataViaMultiAjax().load(loads).done(() => {
			window.Global.ajax({
				method: 'GET',
				url: process.env.REACT_APP_DOMAIN + '/api/relationship',
				data: {relationship_id: this.state.qs.id},
				done: (response) => {
					this.setState({
						relationship: response.relationship[0]
					}, () => {
						let data = {};
						// data.relationship_id = this.state.qs.id;
						data.request_data_relationship = 1;
						data.relationship_address_id = this.state.params.relationship_address_id;
						window.Global.ajax({
							method: 'GET',
							url: process.env.REACT_APP_DOMAIN + '/api/relationship_address',
							data: data,
							done: (response) => {
								this.setState({
									is_loading: false,
									relationship_address: response.relationship_address[0]
								}, () => {
									this.$parent.form2('init', {
										data: response.relationship_address[0]
									});
								});
							},
							fail: () => {

							}
						});
					});
				},
				fail: () => {

				}
			});
		});
	}

	setupAddressChange() {
		if (!this.$parent.find('input[name="is_default_xx"]').prop('checked')) {
			return;
		}

		if (window['t_address_152365']) {
			return;
		}

		window['t_address_152365'] = setTimeout(() => {
			clearTimeout(window['t_address_152365'])
			window['t_address_152365'] = false

			if (window['a_address_152365']) {
				window['a_address_152365'].abort()
			}

			window['a_address_152365'] = window.Global.ajax({
				method: 'GET',
				url: process.env.REACT_APP_DOMAIN + '/api/address_readable',
				data: {
					country: 'TH',
					street: this.$parent.find('input[name="street"]').val(),
					district: this.$parent.find('input[name="district"]').val(),
					city: this.$parent.find('input[name="city"]').val(),
					province: this.$parent.find('input[name="province"]').val(),
					zip_code: this.$parent.find('input[name="zip_code"]').val(),
					phone: this.$parent.find('input[name="phone_number"]').val(),
				},
				done: (response) => {
					if (!response.success) {
						return false;
					}
					this.$parent.find('input[name="bill_line_1"]').val(
						response.address
					)
				}
			})
		}, 1000)
	}

	setupAddress() {
		let ddd = [
			'street',
			'district',
			'city',
			'province',
			'zip_code',
			'phone_number',
		]
		ddd.map((v) => {
			window.$(this.$parent)
				.find('input[name="' + v + '"]')
				.on('keyup.auto', () => {
					this.setupAddressChange()
				}).on('change.auto', () => {
				this.setupAddressChange()
			})

			return true
		})
	}

	create() {
		let data = {};
		data.relationship_id = this.state.qs.id;
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/relationship',
			data: data,
			done: (response) => {
				this.setState({
					is_loading: false,
					relationship: response.relationship[0],
					relationship_address: {
						is_default: true,
						name: response.relationship[0]['name'],
						phone_number: response.relationship[0]['phone'].length ? response.relationship[0]['phone'][0] : ''
					},
				}, () => {
					this.setupJqueryThailand();

					this.$parent = window.$(this.$parent.current);

					let loads = {};
					if (typeof google === 'undefined') {
						loads.google_map = {
							type: 'google_map',
							params: {
								'key': window.Global.google_map_key,
								'libraries': 'places'
							}
						};
					}

					window.Global.getDataViaMultiAjax().load(loads).done(() => {
						this.$parent.find('form').form2('setup', {
							is_default_xx_onChange: () => {
								this.setupAddressChange()
							}
						});
						this.$parent.find('form').form2('submit', {
							method: this.state.mode === 'create' ? 'POST' : 'PUT',
							url: process.env.REACT_APP_DOMAIN + '/api/relationship_address',
							beforeSent: (object) => {
								// console.log(object);
								return object;
							},
							loadingButton: window.$(this.$parent).find('#submit-button'),
							onSuccess: (response) => {
								// console.log(response);
								window.Global.messageTop({
									type: 'positive',
									message: 'บันทึกข้อมูลสำเร็จ'
								});

								if (this.state.qs.back) {
									window.location = this.state.backUrl;
								} else {
									this.props.history.push({
										pathname: '/v2/relationships/address/' + response.relationship_address.id,
										search: "?id=" + this.state.qs.id,
										state: null
									});
								}
							}
						})

						this.setupAddress()
						window.$(this.$parent).find('input[name="is_default_xx"]').prop('checked', true)

					})
				})
			},
			fail: () => {

			}
		});
	}

	fetch() {
		let data = {};
		data.relationship_id = this.state.qs.id;
		data.request_data_relationship = 1;
		data.source = 'shipping';

		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/relationship_address',
			data: data,
			done: (response) => {
				this.setState({
					is_loading: false,
					relationship: response.relationship,
					relationship_address: response.relationship_address
				}, () => {
					this.$parent.find('.Table_root').tablePagination({
						disableContent: true,
						data: response.relationship_address,
						count: response.count,
						onClickPagination: (p) => {
							let qs = window.Global.getAllQueryStrings();
							qs.page = p;
							this.props.history.push(window.Global.getQueryStringLinkFromObject(qs));
						}
					});
				});
				// window.Route.setLink();
			},
			fail: () => {

			}
		});
	}

	renderView() {
		return (
			<div ref={(ref) => {
				this.$parent = window.$(ref);
				// Route.setLink();
			}} className="main ui container">
				<div style={{marginBottom: '1rem'}}>
					<div className="flex row wrap middle-xs">
						<div className="ui huge breadcrumb">
							<a className="section active"
							   href={process.env.REACT_APP_DOMAIN + "/relationships"}>
								ลูกค้าและเจ้าหนี้
							</a>
							{
								this.state.relationship ?
									<>
										<span className="divider" style={{margin: '0px 1rem'}}>/</span>
										<a className="section"
										   href={process.env.REACT_APP_DOMAIN + "/relationships?id=" + this.state.qs.id}>
											{this.state.relationship.name}
										</a>
									</>
									: null
							}
							<span className="divider" style={{margin: '0px 1rem'}}>/</span>
							<Link className="section"
							      to={'/v2/relationships/address?id=' + this.state.qs.id}>ที่อยู่</Link>
							{
								this.state.relationship_address ?
									<>
										<span className="divider" style={{margin: '0px 1rem'}}>/</span>
										<div className="section">{this.state.relationship_address.name}</div>
									</>
									: null
							}
						</div>
					</div>
					<RelationShipAddressMenu id={this.state.qs.id} index={10}/>
				</div>
				<div
					className={this.state.is_loading ? "ui tall stacked loading segment" : "ui tall stacked segment"}>
					<form className="ui form" autoComplete="off">
						<div className="flex row wrap middle-xs Signature_head" style={{padding: '2px 0 14px 0'}}>
							<div className={'text-lg font-bold'}>
								{
									this.state.relationship_address.source === 'billing'
										? 'ข้อมูลที่อยู่สำหรับออกเอกสาร'
										: 'ข้อมูลที่อยู่จัดส่งสินค้า'
								} {
								this.state.relationship_address.is_deleted
									? <span className="ui label red">ยกเลิก</span>
									: null
							}
							</div>
							<div className="flex row right floated">
								{
									!this.state.relationship_address.is_deleted
									&&
									<div className="ui basic gray buttons">
										<button type={"button"} className={"ui button basic"} onClick={() => {
											this.void()
										}}>ลบ
										</button>
										<Link className={"ui button basic"}
										      to={"/v2/relationships/address/" + this.state.relationship_address.id + '/edit?id=' + this.state.qs.id}
										>
											แก้ไข
										</Link>
									</div>
								}
							</div>
						</div>
						<div className="ui divider" style={{margin: '0 0 14px'}}/>
						<div className="flex row wrap padded four column computer">
							<div className="column field">
								<label>ประเภท</label>
								<p>{this.state.relationship_address.source === 'billing'
									? 'ที่อยู่ในการออกเอกสาร'
									: 'ที่อยู่ในการจัดส่งสินค้า'}</p>
							</div>
							<div className="column field">
								<label>ชื่อเรียก</label>
								<p>{this.state.relationship_address.title}</p>
							</div>
							<div className="column field">
								<label>ชื่อ นามสกุล</label>
								<p>{this.state.relationship_address.name}</p>
							</div>
							<div className="column field">
								<label>เบอร์โทรศัพท์</label>
								<p>{this.state.relationship_address.phone_number ? this.state.relationship_address.phone_number.replace(/\+66/g, "0") : ''}</p>
							</div>
							<div className="column field">
								<label>ทีอยู่</label>
								<p>{this.state.relationship_address.address_line_1}
									{
										this.state.relationship_address.country ?
											<span> ({this.state.relationship_address.country})</span>
											: null
									}
								</p>
							</div>
							<div className="column field">
								<label>ที่อยู่บนเอกสาร 1</label>
								<p>{this.state.relationship_address.bill_line_1}</p>
							</div>
							<div className="column field">
								<label>ที่อยู่บนเอกสาร 2</label>
								<p>{this.state.relationship_address.bill_line_2}</p>
							</div>
							<div className="column field">
								<label>หมายเหตุ</label>
								<p>{this.state.relationship_address.remark}</p>
							</div>
							<div className="column field">
								<label>ประเภทที่อยู่</label>
								<div>
									{
										this.state.relationship_address.type === 'home' ?
											<div className="ui label green">บ้าน</div>
											: null
									}
									{
										this.state.relationship_address.type === 'work' ?
											<div className="ui label green">ที่ทำงาน</div>
											: null
									}
								</div>
							</div>
							<div className="column field">
								<label>เป็นที่อยู่เริ่มต้น</label>
								<p>
									{this.state.relationship_address.is_default ?
										<i className="icon check green"/>
										: <i className="icon times" style={{color: 'red'}}/>
									}
								</p>
							</div>
						</div>
						<div className="flex row wrap padded two column computer">
							<div className="column field">
								<div data-form2_text=""
								     self=""
								     data-form2_setup="true"
								     data-form2_type="google_map_lat_lng"
								     data-id="address"
								     data-lat_input_name="lat"
								     data-lng_input_name="lng"
								     data-default_lat={this.state.relationship_address.lat}
								     data-default_lng={this.state.relationship_address.lng}
								     data-height="400"
								     data-zoom="15"
								     data-draggable="false"
								     data-show_manual_lat_lng_input="false"
								     data-full_screen="true"
								     data-readonly="true"
								     data-places_searchbox="false"></div>
							</div>
							<div className="column field">
								<label>Latitude & Longitude</label>
								<p>{this.state.relationship_address.lat}, {this.state.relationship_address.lng}</p>
							</div>
						</div>
					</form>
				</div>
			</div>
		);
	}

	renderList() {
		return (
			<div ref={(ref) => {
				if (!ref) return;
				this.$parent = window.$(ref);
			}}
			     key={'ddd' + window.Global.getRandomInt(1, 99999999)}
			     className="main ui container">
				<div style={{marginBottom: '1rem'}}>
					<div className="flex row wrap middle-xs">
						<div className="ui huge breadcrumb">
							<a className="section active"
							   href={process.env.REACT_APP_DOMAIN + "/relationships"}>
								ลูกค้าและเจ้าหนี้
							</a>
							{
								this.state.relationship ?
									<>
										<span className="divider" style={{margin: '0px 1rem'}}>/</span>
										<a className="section"
										   href={process.env.REACT_APP_DOMAIN + "/relationships?id=" + this.state.qs.id}>
											{this.state.relationship.name}
										</a>
									</>
									: null
							}

							<span className="divider" style={{margin: '0px 1rem'}}>/</span>
							<div className="section">ที่อยู่</div>
						</div>

						<div className="right floated">
							<Link id="addSaleOrderButton"
							      to={"/v2/relationships/address/new?id=" + this.state.qs.id}
							      className="ui positive button">
								เพิ่มที่อยู่จัดส่งสินค้า
							</Link>
						</div>
					</div>
					<RelationShipAddressMenu id={this.state.qs.id} index={10}/>
				</div>
				<div className="flex row wrap padded">
					<div className="col-xs-16 padded">
						<div className="ui basic table can click Table_root td-top-xs" style={{marginTop: 0}}>
							<div className="thead">
								<div className="tr">
									<div className="th span3">ชื่อ</div>
									<div className="th span2">เบอร์โทรศัพท์</div>
									<div className="th span7">ที่อยู่</div>
									<div className="th span2">ประเภทที่อยู่</div>
									<div className="th span2">เป็นที่อยู่เริ่มต้น</div>
								</div>
							</div>
							<div className="tbody">
								{
									this.state.is_loading
										? <div className="tr">
											<div className="td center aligned" data-info="nodata">
												<div className="ui active centered inline small loader"/>
											</div>
										</div>
										: null
								}
								{
									this.state.relationship_address.length === 0
									&& !this.state.is_loading
									&& (
										!window.Global.getAllQueryStrings().page
										|| window.Global.getAllQueryStrings().page === '1'
									)
										? <div className="tr">
											<div className="td span16" style={{textAlign: 'center'}}>ไม่พบข้อมูล</div>
										</div>
										: null
								}
								{
									this.state.relationship_address
									&& this.state.relationship_address.length > 0 ?
										this.state.relationship_address.map((relationship_address, relationship_address_index) => {
											return (
												<Link className="tr"
												      to={"/v2/relationships/address/" + relationship_address.id + "?id=" + this.state.qs.id}
												      key={relationship_address_index}>
													<div className="td span3">
														<div><strong>{relationship_address.name}</strong>
														</div>
													</div>
													<div className="td span2">
														<div>{relationship_address.phone_number.replace(/\+66/g, "0")}</div>
													</div>
													<div className="td span7">
														<div>{relationship_address.address_line_1}
															{
																relationship_address.country ?
																	<span> ({relationship_address.country})</span>
																	: null
															}
														</div>
													</div>
													<div className="td span2">
														<div>
															{
																relationship_address.type === 'home' ?
																	<div className="ui label green">บ้าน</div>
																	: null
															}
															{
																relationship_address.type === 'work' ?
																	<div className="ui label green">ที่ทำงาน</div>
																	: null
															}
														</div>
													</div>
													<div className="td span2">
														<div>{relationship_address.is_default ?
															<i className="icon check green"/>
															: null
														}</div>
													</div>
												</Link>
											)
										})
										: null
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	render() {
		if (this.state.mode === 'list') {
			return this.renderList();
		}
		if (this.state.mode === 'view') {
			return this.renderView();
		}
		if (this.state.mode === 'edit' && !this.state.relationship_address) return (<div/>);

		return (
			<div ref={this.$parent}
			     className="main ui container">
				<div style={{marginBottom: '1rem'}}>
					<div className="flex row wrap middle-xs">
						<div className="ui huge breadcrumb">
							<a className="section active"
							   href={process.env.REACT_APP_DOMAIN + "/relationships"}>
								ลูกค้าและเจ้าหนี้
							</a>
							{
								this.state.relationship ?
									<>
										<span className="divider" style={{margin: '0px 1rem'}}>/</span>
										<a className="section"
										   href={process.env.REACT_APP_DOMAIN + "/relationships?id=" + this.state.qs.id}>
											{this.state.relationship.name}
										</a>
									</>
									: null
							}
							<span className="divider" style={{margin: '0px 1rem'}}>/</span>
							<Link className="section"
							      to={'/v2/relationships/address?id=' + this.state.qs.id}>ที่อยู่</Link>
							<span className="divider" style={{margin: '0px 1rem'}}>/</span>
							<div className="section">{this.state.mode === "create" ? "ใหม่" : "แก้ไข"}</div>
						</div>
					</div>
					<RelationShipAddressMenu id={this.state.qs.id} index={10}/>
				</div>
				<form id="Signature_root"
				      className={this.state.is_loading ? "ui form ui tall stacked loading segment" : "ui form ui tall stacked segment"}
				      autoComplete="off">
					<div className="flex row wrap middle-xs Signature_head" style={{padding: '2px 0 14px 0'}}>
						<div className={'text-lg font-bold'}>
							{this.state.mode === 'edit' ? 'แก้ไข' : 'เพิ่ม'}
							{
								this.state.qs.source === 'billing'
								|| this.state.relationship_address.source === 'billing'
									? 'ข้อมูลที่อยู่สำหรับออกเอกสาร'
									: 'ข้อมูลที่อยู่จัดส่งสินค้า'
							}
						</div>
					</div>
					<div className="ui divider" style={{margin: '0 0 14px 0'}}/>
					<div className={"flex row wrap padded two column computer"}>
						<div className={"column"}>
							<div className={"flex row wrap padded two column computer"}>
								{/*<div className="column field required">*/}
								{/*	<label>ประเภท</label>*/}
								{/*	<select name="source"*/}
								{/*	        className="ui dropdown"*/}
								{/*	        defaultValue={*/}
								{/*		        this.state.relationship_address*/}
								{/*		        && this.state.relationship_address.source*/}
								{/*			        ? this.state.relationship_address.source*/}
								{/*			        : 'shipping'*/}
								{/*	        }*/}
								{/*	        data-form2_setup="true">*/}
								{/*		<option value="billing">ที่อยู่ในการออกเอกสาร</option>*/}
								{/*		<option value="shipping">ที่อยู่ในการจัดส่งสินค้า</option>*/}
								{/*	</select>*/}
								{/*</div>*/}
								<input type="hidden"
								       name="source"
								       defaultValue={
									       this.state.relationship_address
									       && this.state.relationship_address.source
										       ? this.state.relationship_address.source
										       : this.state.qs.source === 'billing'
											       ? 'billing'
											       : 'shipping'
								       }
								/>
								<div className="column field required">
									<label>ชื่อ นามสกุล</label>
									<input name={"name"}
									       defaultValue={this.state.relationship_address && this.state.relationship_address.name ? this.state.relationship_address.name : ''}/>
								</div>
								<div className="column field required">
									<label>เบอร์โทรศัพท์</label>
									<input name={"phone_number"}
									       defaultValue={this.state.relationship_address && this.state.relationship_address.phone_number ? this.state.relationship_address.phone_number : ''}/>
								</div>
								<div className="column field required">
									{/*<label>&nbsp;&nbsp;</label>*/}
									<div className="ui checkbox" data-form2_setup="done"
									     ref={(ref) => {
										     window.$(ref).checkbox();
									     }}
									>
										<input type="checkbox" name="is_default" id="is_default" value="1" tabIndex="0"
										       defaultChecked={this.state.relationship_address && this.state.relationship_address.is_default}
										       className="hidden"/>
										<label htmlFor="is_default"><b>ตั้งเป็นที่อยู่เริ่มต้น</b></label>
									</div>
								</div>
								<div className="column field required flex">
									<label>ประเภทที่อยู่</label>
									<div className={"flex row middle-xs"} style={{flex: 1}}>
										<div className={"ui radio checkbox"}
										     ref={(ref) => {
											     window.$(ref).checkbox(this.state.relationship_address.type === 'home' || this.state.mode === 'create' ? "check" : null);
										     }}
										     style={{marginRight: 15}}>
											<input type="radio"
											       id={"home"}
											       name="type"
											       value={"home"}
											/>
											<label htmlFor={"home"}>บ้าน</label>
										</div>
										<div className={"ui radio checkbox"}
										     ref={(ref) => {
											     window.$(ref).checkbox(this.state.relationship_address.type === 'work' ? "check" : null);
										     }}
										>
											<input type="radio"
											       id={"work"}
											       name="type"
											       value={"work"}
											/>
											<label htmlFor={"work"}>ที่ทำงาน</label>
										</div>
									</div>
								</div>
							</div>
							<div className="column field required">
								<label>ที่อยู่</label>
								<input name={"street"}
								       defaultValue={this.state.relationship_address.street}/>
							</div>
							<div className={"flex row wrap padded two column computer"}>
								<div className="column field required" id={"readonly-white"}>
									<label>ตำบล/แขวง</label>
									<input name={"district"} id={"district"}
									       defaultValue={this.state.relationship_address.district}/>
								</div>
								<div className="column field required" id={"readonly-white"}>
									<label>อำเภอ/เขต</label>
									<input name={"city"} id={"city"}
									       defaultValue={this.state.relationship_address.city}/>
								</div>
								<div className="column field required" id={"readonly-white"}>
									<label>จังหวัด</label>
									<input name={"province"} id={"province"}
									       defaultValue={this.state.relationship_address.province}/>
								</div>
								<div className="column field required" id={"readonly-white"}>
									<label>รหัสไปรษณีย์</label>
									<input name={"zip_code"} id={"zipcode"}
									       defaultValue={this.state.relationship_address.zip_code}/>
								</div>
							</div>
							<div className={'column p-4 bg-yellow-100'}>
								<div className="column field required">
									<label className={'flex flex-row items-center justify-between'}>
										<span>ที่อยู่บนเอกสาร 1</span>
										{/*<span className="link"*/}
										{/*                        style={{marginLeft: '0.5rem'}}*/}
										{/*                        onClick={() => {*/}
										{/*	                        window.Global.ajax({*/}
										{/*		                        method: 'GET',*/}
										{/*		                        url: process.env.REACT_APP_DOMAIN + '/api/address_readable',*/}
										{/*		                        data: {*/}
										{/*			                        country: 'TH',*/}
										{/*			                        street: this.$parent.find('input[name="street"]').val(),*/}
										{/*			                        district: this.$parent.find('input[name="district"]').val(),*/}
										{/*			                        city: this.$parent.find('input[name="city"]').val(),*/}
										{/*			                        province: this.$parent.find('input[name="province"]').val(),*/}
										{/*			                        zip_code: this.$parent.find('input[name="zip_code"]').val(),*/}
										{/*			                        phone: this.$parent.find('input[name="phone_number"]').val(),*/}
										{/*		                        },*/}
										{/*		                        done: (response) => {*/}
										{/*			                        if (!response.success) {*/}
										{/*				                        return false;*/}
										{/*			                        }*/}
										{/*			                        this.$parent.find('input[name="bill_line_1"]').val(*/}
										{/*				                        response.address*/}
										{/*			                        )*/}
										{/*		                        }*/}
										{/*	                        });*/}
										{/*                        }}>ใช้ที่อยู่เหมือนด้านบน</span>*/}
										&nbsp;&nbsp;&nbsp;&nbsp;
										<div className="ui checkbox"
										     data-form2_setup="done"
										>
											<input type="checkbox"
											       name="is_default_xx"
											       id="is_default_xx"
											       value="1"
											       tabIndex="0"
											       defaultChecked={false}
											       className="hidden"
											/>
											<label htmlFor="is_default_xx">
												<b>ใช้ที่อยู่เหมือนด้านบน</b>
											</label>
										</div>
									</label>
									<input name={"bill_line_1"}
									       defaultValue={this.state.relationship_address.bill_line_1}
									/>
								</div>
								<div className="column field">
									<label>ที่อยู่บนเอกสาร 2</label>
									<input name={"bill_line_2"}
									       defaultValue={this.state.relationship_address.bill_line_2}
									       placeholder={'ไม่ระบุ'}
									/>
								</div>
							</div>
							<div className="column col-xs-16 field">
								<label>ตั้งชื่อเรียก</label>
								<input name={"title"}
								       defaultValue={
									       this.state.relationship_address
									       && this.state.relationship_address.title
										       ? this.state.relationship_address.title
										       : ''
								       }
								       placeholder={'ไม่ระบุ'}
								/>
							</div>
							<div className="column field">
								<label>หมายเหตุ</label>
								<textarea name={"remark"}
								          placeholder={'ไม่ระบุ'}
								          defaultValue={this.state.relationship_address.remark}
								/>
							</div>
						</div>
						<div className={"column"}>
							<div data-form2_text=""
							     self=""
							     data-form2_setup="true"
							     data-form2_type="google_map_lat_lng"
							     data-id="address"
							     data-lat_input_name="lat"
							     data-lng_input_name="lng"
							     data-default_lat={this.state.relationship_address.lat}
							     data-default_lng={this.state.relationship_address.lng}
							     data-height="400"
							     data-zoom="15"
							     data-draggable="true"
							     data-show_manual_lat_lng_input="true"
							     data-full_screen="true"
							     data-places_searchbox="false"></div>
						</div>
					</div>

					<div className="ui error message"/>
					<br/>
					<br/>
					<div className="flex row">
						<div className="right floated">
							{
								this.state.relationship && this.state.relationship.id ?
									<input type={"hidden"} name={"relationship_id"}
									       defaultValue={this.state.relationship.id}/>
									: null
							}
							{
								this.state.relationship_address && this.state.relationship_address.id ?
									<input type={"hidden"} name={"relationship_address_id"}
									       defaultValue={this.state.relationship_address.id}/>
									: null
							}
							<input type={"hidden"} name={"country"} value={"TH"}/>

							<a href={this.state.backUrl}
							   className={"ui button"}>ยกเลิก</a>
							<button id="submitButton" className="ui positive button" type="submit">
								{this.state.mode === 'create' ? 'บันทึกข้อมูล' : null}
								{this.state.mode === 'edit' ? 'บันทึกข้อมูล' : null}
							</button>
						</div>
					</div>
				</form>
			</div>
		);
	}


	void() {
		window.Global.confirm({
			title: 'ยืนยันลบข้อมูล',
			content: '<form class="ui form">\n\t<p>โปรดยืนยันลบข้อมูล การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้</p>\n\t<div class="ui error message"></div>\n</form>',
			cancel_text: 'ไม่ดำเนินการ',
			approve_text: 'ลบข้อมูล',
			onShowToSetupForm: ($modal) => {
				$modal.find('form').form2('setup');
				$modal.find('form').form2('submit', {
					method: 'DELETE',
					url: process.env.REACT_APP_DOMAIN + '/api/relationship_address',
					loadingButton: $modal.find('.button.approve'),
					beforeSent: (data) => {
						data.relationship_address_id = this.state.relationship_address.id;
						return data;
					},
					onSuccess: (response) => {
						$modal.modal('hide');
						window.Global.messageTop({
							type: 'positive',
							message: 'ลบข้อมูลสำเร็จ'
						});
						this.props.history.push({
							pathname: '/v2/relationships/address',
							search: "?id=" + this.state.qs.id,
							state: null
						});
					}
				});
			}
		});
	}
}

export class RelationShipAddressMenu extends React.Component {
	render() {
		return (
			<div className="ui menu flex row wrap Setting_menu">
				<a className={this.props.index === 0 ? "item active" : "item"}
				   href={process.env.REACT_APP_DOMAIN + "/relationships?id=" + this.props.id}>ข้อมูลทั่วไป</a>
				<a className={this.props.index === 0 ? "item active" : "item"}
				   href={process.env.REACT_APP_DOMAIN + "/relationships/branch?id=" + this.props.id}>สาขา</a>
				<a className={this.props.index === 0 ? "item active" : "item"}
				   href={process.env.REACT_APP_DOMAIN + "/relationships/credit?id=" + this.props.id}>เครดิตเงินเชื่อ</a>
				<a className={this.props.index === 0 ? "item active" : "item"}
				   href={process.env.REACT_APP_DOMAIN + "/relationships/billing_note_invoice?id=" + this.props.id}>ใบวางบิล</a>
				<a className={this.props.index === 0 ? "item active" : "item"}
				   href={process.env.REACT_APP_DOMAIN + "/relationships?id=" + this.props.id + '&type=pay_out_debt&method=pay_in'}>รับชำระหนี้</a>
				<a className={this.props.index === 0 ? "item active" : "item"}
				   href={process.env.REACT_APP_DOMAIN + "/relationships/payments?id=" + this.props.id + '&type=pay_out_debt&method=pay_out'}>จ่ายชำระหนี้</a>
				<a className={this.props.index === 0 ? "item active" : "item"}
				   href={process.env.REACT_APP_DOMAIN + "/relationships/payments/debt-bring-forward?id=" + this.props.id + '&method=pay_in'}>ลูกหนี้ยกมา</a>
				<a className={this.props.index === 0 ? "item active" : "item"}
				   href={process.env.REACT_APP_DOMAIN + "/relationships/payments/debt-bring-forward?id=" + this.props.id + '&method=pay_out'}>เจ้าหนี้ยกมา</a>
				<a className={this.props.index === 0 ? "item active" : "item"}
				   href={process.env.REACT_APP_DOMAIN + "/relationships/account?id=" + this.props.id}>บัญชีผู้ใช้งาน</a>
				<Link className={this.props.index === 10 ? "item active" : "item"}
				      to={"/v2/relationships/address?id=" + this.props.id}>ที่อยู่จัดส่งสินค้า</Link>
			</div>
		);
	}
}
